"use client";
import { useState as c, useEffect as p } from "react";
import { registerStoryblokBridge as b } from "./storyblok-js.mjs";
const n = (e = null, d = {}) => {
  const [f, s] = c(e), o = (e == null ? void 0 : e.internalId) ?? (e == null ? void 0 : e.id) ?? 0, r = typeof window < "u" && typeof window.storyblokRegisterEvent < "u";
  return p(() => {
    s(e), !(!r || !e) && b(
      o,
      (u) => s(u),
      d
    );
  }, [e]), f;
};
export {
  n as useStoryblokState
};
